import React from 'react';
import PropTypes from 'prop-types';
import MagnifyingGlass from '../../../../Assets/images/svg/dar_magnifying.svg';
import '../../NewRequest/techSession.scss';

const SearchBar = ({ searchText, handleSearch }) => {
  return (
    <div className="tech-session-users-search">
      <img src={MagnifyingGlass} alt="Search" />
      <input
        id="tech-session-input"
        type="text"
        placeholder="Search..."
        value={searchText}
        onChange={handleSearch}
      />
    </div>
  );
};

SearchBar.propTypes = {
  searchText: PropTypes.string.isRequired,
  handleSearch: PropTypes.func.isRequired,
};

export default SearchBar;
